import { Controller } from "@hotwired/stimulus"

// Searchable dropdown controller
// Filters dropdown items based on search input
// Shows/hides dropdown on focus/blur
export default class extends Controller {
  static targets = ["input", "item", "dropdown"]

  connect() {
    this.hideTimeout = null
    // Clear search input and reset filter on connect (including after TurboFrame updates)
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
      this.filter()
    }
    // Ensure dropdown is hidden on connect
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add("hidden")
    }
  }

  disconnect() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }
  }

  filter() {
    const searchTerm = this.inputTarget.value.toLowerCase()

    this.itemTargets.forEach(item => {
      const text = item.textContent.toLowerCase()

      if (text.includes(searchTerm)) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })
  }

  showDropdown() {
    // Cancel any pending hide
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }

    this.dropdownTarget.classList.remove("hidden")
  }

  hideDropdown() {
    // Delay hiding to allow clicks on dropdown items to register
    this.hideTimeout = setTimeout(() => {
      this.dropdownTarget.classList.add("hidden")
      this.hideTimeout = null
    }, 200)
  }

  preventHide(event) {
    // Prevent blur from hiding dropdown when clicking inside
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.filter()
  }
}
